(function () {
    'use strict';

    var PRODUCT_CACHE = {};

    function fetchProduct(handle) {
        if (!handle) return Promise.resolve(null);
        if (PRODUCT_CACHE[handle]) return Promise.resolve(PRODUCT_CACHE[handle]);
        return fetch('/products/' + handle + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (d) { if (d) PRODUCT_CACHE[handle] = d; return d; })
            .catch(function () { return null; });
    }

    function activeCurrency() {
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
            return window.Shopify.currency.active;
        }
        return 'GBP';
    }

    function money(cents) {
        if (typeof cents !== 'number' || isNaN(cents)) return '';
        try {
            return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
                style: 'currency', currency: activeCurrency()
            }).format(cents / 100);
        } catch (e) { return '£' + (cents / 100).toFixed(2); }
    }

    function escapeHtml(s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    }

    function round2(n) { return Math.round(n * 100) / 100; }

    function initSection(root) {
        var sectionId = root.getAttribute('data-pcalc-section');
        var settings = (window.PCALC_SETTINGS && window.PCALC_SETTINGS[sectionId]) || {};
        var group = settings[settings.group] || {};
        var t1 = group.tier1 || {};
        var t2 = group.tier2 || {};

        var cov1 = Number(t1.coverage) > 0 ? Number(t1.coverage) : 10;
        var cov2 = Number(t2.coverage) > 0 ? Number(t2.coverage) : 5;
        var showPrices = settings.showPrices !== false;

        var lengthInput = root.querySelector('[data-pcalc-length]');
        var widthInput = root.querySelector('[data-pcalc-width]');
        var lengthUnit = root.querySelector('[data-pcalc-length-unit]');
        var widthUnit = root.querySelector('[data-pcalc-width-unit]');
        var areaField = root.querySelector('[data-pcalc-area]');
        var errorEl = root.querySelector('[data-pcalc-error]');
        var resultEl = root.querySelector('[data-pcalc-result]');
        var cardsEl = root.querySelector('[data-pcalc-cards]');
        var noteEl = root.querySelector('[data-pcalc-note]');
        var cartBtn = root.querySelector('[data-pcalc-cart]');

        // Resolved product data, keyed by tier.
        var products = { tier1: null, tier2: null };
        var recommendation = [];

        Promise.all([fetchProduct(t1.handle), fetchProduct(t2.handle)]).then(function (res) {
            products.tier1 = res[0];
            products.tier2 = res[1];
            recompute();
        });

        function currentAreaM2() {
            var L = parseFloat(lengthInput.value);
            var W = parseFloat(widthInput.value);
            if (isNaN(L) || isNaN(W) || L <= 0 || W <= 0) return 0;
            var fL = parseFloat(lengthUnit.value) || 1;
            var fW = parseFloat(widthUnit.value) || 1;
            return (L * fL) * (W * fW); // metres × metres = m²
        }

        // Work out the bottle combo for an area (4.1L + 2L, no 800ml).
        function combo(area) {
            var big = Math.floor(area / cov1);
            var rem = area - big * cov1;
            var small = 0;
            if (rem > cov2 + 0.0001) big += 1;
            else if (rem > 0.0001) small = 1;
            if (big === 0 && small === 0) small = 1; // minimum one 2L
            return { big: big, small: small };
        }

        function tierItem(tierKey, qty, cfg) {
            var p = products[tierKey];
            var v = p && p.variants && p.variants[0];
            return {
                tierKey: tierKey,
                qty: qty,
                label: (p && p.title) || cfg.label || '',
                sizeLabel: cfg.label || (p && p.title) || '',
                handle: cfg.handle,
                url: p ? '/products/' + p.handle : (cfg.handle ? '/products/' + cfg.handle : '#'),
                variantId: v ? v.id : null,
                price: v && typeof v.price === 'number' ? v.price : null,
                image: (p && (p.featured_image || (p.images && p.images[0]))) || null,
                available: v ? v.available !== false : false,
                coverage: tierKey === 'tier1' ? cov1 : cov2
            };
        }

        function recompute() {
            var area = currentAreaM2();

            if (areaField) areaField.value = area > 0 ? round2(area) : '—';
            if (errorEl) errorEl.textContent = '';

            if (area <= 0) {
                if (resultEl) resultEl.hidden = true;
                recommendation = [];
                return;
            }

            var c = combo(area);
            var items = [];
            if (c.big > 0) items.push(tierItem('tier1', c.big, t1));
            if (c.small > 0) items.push(tierItem('tier2', c.small, t2));
            recommendation = items;

            renderCards(items, area);
            if (resultEl) resultEl.hidden = false;
        }

        function renderCards(items, area) {
            if (!cardsEl) return;

            cardsEl.innerHTML = items.map(function (it) {
                var priceLine = (showPrices && it.price != null)
                    ? '<span class="pcalc-card-price">' + money(it.price * it.qty) + '</span>' : '';
                var media = it.image
                    ? '<img src="' + escapeHtml(it.image) + '" alt="' + escapeHtml(it.label) + '" loading="lazy">'
                    : '<span class="pcalc-card-noimg">No image</span>';
                var stock = it.available ? '' : '<span class="pcalc-card-oos">Out of stock</span>';
                return '' +
                    '<a class="pcalc-card" href="' + escapeHtml(it.url) + '">' +
                        '<span class="pcalc-card-media">' + media + '</span>' +
                        '<span class="pcalc-card-body">' +
                            '<strong class="pcalc-card-qty">' + it.qty + ' × ' + escapeHtml(it.sizeLabel) + '</strong>' +
                            priceLine + stock +
                        '</span>' +
                    '</a>';
            }).join('');

            var totalCover = items.reduce(function (s, i) { return s + i.qty * i.coverage; }, 0);
            if (noteEl) {
                noteEl.innerHTML =
                    'Covers up to <strong>' + round2(totalCover) + ' m²</strong> for your ' +
                    round2(area) + ' m² area. Coverage may vary with stone size and depth.';
            }

            if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = 'Add All to Basket'; }
        }

        [lengthInput, widthInput].forEach(function (el) {
            if (el) el.addEventListener('input', recompute);
        });
        [lengthUnit, widthUnit].forEach(function (el) {
            if (el) el.addEventListener('change', recompute);
        });

        if (cartBtn) {
            cartBtn.addEventListener('click', function () {
                if (!recommendation.length) return;

                var addable = recommendation.filter(function (i) { return i.available && i.variantId; });
                if (!addable.length) {
                    if (errorEl) errorEl.textContent = 'These products are currently unavailable.';
                    return;
                }

                cartBtn.disabled = true;
                cartBtn.textContent = 'Adding…';

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify({
                        items: addable.map(function (i) {
                            return {
                                id: i.variantId,
                                quantity: i.qty,
                                properties: { 'Calculated for': round2(currentAreaM2()) + ' m²' }
                            };
                        })
                    })
                }).then(function (res) {
                    if (!res.ok) throw new Error('cart');
                    if (settings.cartRedirect === false) {
                        cartBtn.textContent = 'Added ✓';
                        document.dispatchEvent(new CustomEvent('pcalc:added'));
                    } else {
                        window.location.href = '/cart';
                    }
                }).catch(function () {
                    if (errorEl) errorEl.textContent = 'Sorry, we couldn\'t add those. Please try again.';
                    cartBtn.disabled = false;
                    cartBtn.textContent = 'Add All to Basket';
                });
            });
        }
    }

    function boot() {
        document.querySelectorAll('[data-pcalc-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
        var el = e.target.querySelector ? e.target.querySelector('[data-pcalc-section]') : null;
        if (el) initSection(el);
    });

})();
